import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupComponent } from './popup.component';
import { LegalComponent } from './legal/legal.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {RouterLink} from "@angular/router";
import {ProgressBarMode, MatProgressBarModule} from '@angular/material/progress-bar';
import {CommunicationComponent} from "./communication/communication.component";
import {MatIconModule} from "@angular/material/icon";
import {RequalificationComponent} from "./requalification/requalification.component";



@NgModule({
  declarations: [
    PopupComponent,
    LegalComponent,
    CommunicationComponent
  ],
  exports: [
    PopupComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    RouterLink,
    MatProgressBarModule,
    RequalificationComponent
  ]
})
export class PopupModule { }
